<zwi-simple-page>
  <zwi-email-sent-message [email]="email"></zwi-email-sent-message>
</zwi-simple-page>
